export default "__VITE_ASSET__C6U$8NPt__"